import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'sanitizeUrl' })
export class SanitizeUrlPipe implements PipeTransform {
    private domSanitizer: DomSanitizer = inject(DomSanitizer);

    transform(value: string | undefined): SafeHtml {
        if (!value) return '';

        return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
    }
}
